"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleTags = void 0;
var article_tags_1 = require("./article-tags");
Object.defineProperty(exports, "ArticleTags", { enumerable: true, get: function () { return article_tags_1.ArticleTags; } });
